/**
 * HTML-escape a value for safe interpolation into an HTML string.
 *
 * Escapes the five characters that can break out of either text content OR a
 * single/double-quoted attribute value: `& < > " '`. The Loom detail panel is
 * built as HTML strings (`panel.innerHTML = …`) that interpolate skill-derived
 * ids, names and namespaces into both positions — e.g. `data-goto="${…}"` — so
 * escaping only `& < >` (text-safe but attribute-unsafe) would still let a `"`
 * break out. Every interpolated, non-constant value in loom-render.ts routes
 * through this one helper.
 *
 * Today skill names come from developer-authored `*.skill.ts` files (committed
 * code), so this is defence-in-depth. It stops being merely defensive the
 * moment any part of the graph is sourced from live/editable data.
 */
const HTML_ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

export function escapeHtml(value: unknown): string {
  return String(value ?? '').replace(/[&<>"']/g, (c) => HTML_ENTITIES[c] ?? c)
}
